import { useTranslation } from 'react-i18next'
import { TbMessageCircle2 } from 'react-icons/tb'
import { useModalContext } from 'features/common'
import { Link } from 'react-router-dom'
import { Driver } from '../../../drivers'
import { Client } from '../../../clients'
import { routePaths } from '../../../../routes'

interface Props {
  routeId: number
  passengers: number
  luggage: number
  messageCount: number
  driver: Driver | null
  client: Client
}

export const RideDetails = (props: Props) => {
  const { client, driver, routeId, passengers, luggage, messageCount } = props
  const { onOpen } = useModalContext()
  const { t } = useTranslation()

  const driversFullName = `${driver?.user?.first_name ?? '-'} ${driver?.user?.last_name ?? '-'}`
  const clientFullName = `${client.user?.first_name ?? '-'} ${client.user?.last_name ?? '-'}`

  return (
    <div className="flex flex-col gap-5 lg:px-10 w-full">
      {driver && (
      <div className="flex gap-2">
        <p>{`${t('driversName')}:`}</p>
        <Link
          to={`${routePaths.drivers}/${driver.id}`}
          className="capitalize font-bold hover:opacity-70 transition-opacity duration-300 underline"
        >
          {driversFullName}
        </Link>
      </div>
      )}
      <div className="flex gap-2">
        <p>{`${t('clientsName')}:`}</p>
        <Link
          to={`${routePaths.clients}/${client.id}`}
          className="capitalize font-bold hover:opacity-70 transition-opacity duration-300 underline"
        >
          {clientFullName}
        </Link>
      </div>
      <div className="text-sm flex">
        <p className="text-dark-gray border-r-2 pr-2 mr-2">
          <span className="text-base font-bold">{passengers}</span>
          {' '}
          {t('passengers')}
        </p>
        <p className="text-dark-gray">
          <span className="text-base font-bold">{luggage}</span>
          {' '}
          {t('luggagePcs')}
        </p>
      </div>
      <button
        disabled={messageCount === 0}
        onClick={() => onOpen({ resourceId: routeId, message: 'message' })}
        type="button"
        className="text-dark-gray w-max flex gap-1 items-center hover:opacity-80 transition-opacity duration-300"
      >
        <TbMessageCircle2 />
        <span>{messageCount}</span>
        <span>{t('messages')}</span>
      </button>
    </div>
  )
}
